export default "/_next/static/e2aea72265b459b9407f940fa10fee84.svg";